<template>
    <div>
        <h6 style="font-weight: 400; margin: 0px !important; padding: 0px !important">
            {{ VALUE }} - {{ VALUE2 }}
        </h6>
    </div>
</template>
<script>
export default {
    data() {
        return {
            VALUE: "",
            VALUE2: ""
        };
    },
    created() {
        this.VALUE = this.params.data.NAME1;
        this.VALUE2 = this.params.data.NAME2;

    },
};
</script>
      